export default __webpack_public_path__ + "static/media/handshake.6cb09ef4.png";